import React, { useLayoutEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// import hooks
import { useRouteInfo } from 'js/hooks/useRouteInfo';

export const fadeVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.4, 0, 0.2, 1],
    },
  },
  exit: {
    opacity: 0.5,
    filter: 'brightness(20%) blur(2px)',
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 1, 1],
    },
  },
};

export const pageVariants = {
  initial: {
    // clipPath: 'inset(0 0 0 100%)',
    x: '100%',
    opacity: 1,
  },
  animate: {
    // clipPath: 'inset(0 0 0 0)',
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.55,
      ease: [0.4, 0, 0.2, 1],
    },
  },
  exit: {
    // clipPath: 'inset(0 10% 0 0)',
    x: '-10%',
    filter: 'brightness(20%) blur(2px)',
    transition: {
      duration: 0.5,
      ease: [0.4, 0, 1, 1],
    },
  },
};

const TransitionPage = ({ children }) => {
  const { location, state: { backgroundLocation = false } = {}, previousLocation } = useRouteInfo();

  // const isFavoritesTransition = location.pathname === '/favorites' || previousLocation?.pathname === '/favorites';

  // const variants = isFavoritesTransition ? pageVariants : fadeVariants;

  useLayoutEffect(() => {
    if (!backgroundLocation) {
      window.scrollTo(0, 0);
    }
  }, [backgroundLocation]);

  return (
    <AnimatePresence pathe={location.pathname}>
      <motion.div
        variants={fadeVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        style={{
          width: '100%',
          position: 'absolute',
          height: '100%',
        }}
        onAnimationStart={() => {
          document.body.style.overflowX = 'hidden';
        }}
        onAnimationComplete={() => {
          document.body.style.overflowX = 'hidden';
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default TransitionPage;
